module.exports = __webpack_public_path__ + "static/media/Icon - solarpower.34b38a3e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/elements/Icon - solarpower.svg
// module id = 193
// module chunks = 0